function getSectionIdFromElement(element) {
  const productInfo = element.closest('product-info');
  return productInfo ? productInfo.dataset.section : null;
}

async function refreshPriceAndCards(sectionId, variantId) {
  if (!sectionId || !variantId) return;

  const url = new URL(window.location.href);
  url.searchParams.set('variant', variantId);
  url.searchParams.set('section_id', sectionId);

  try {
    const response = await fetch(url.toString(), { credentials: 'same-origin' });
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const currentPrice = document.querySelector(`#price-${sectionId}`);
    const updatedPrice = doc.querySelector(`#price-${sectionId}`);
    if (currentPrice && updatedPrice) {
      currentPrice.outerHTML = updatedPrice.outerHTML;
    }

    const currentCards = document.querySelector(`#SimpleVolumePricingCards-${sectionId}`);
    const updatedCards = doc.querySelector(`#SimpleVolumePricingCards-${sectionId}`);

    if (currentCards && updatedCards) {
      currentCards.outerHTML = updatedCards.outerHTML;
    } else if (currentCards && !updatedCards) {
      currentCards.remove();
    } else if (!currentCards && updatedCards) {
      const priceNode = document.querySelector(`#price-${sectionId}`);
      if (priceNode) {
        priceNode.insertAdjacentHTML('afterend', updatedCards.outerHTML);
      }
    }

    updateActiveVolumePricingCard(sectionId);
  } catch (error) {
    console.error('Failed to refresh price/cards:', error);
  }
}

function updateActiveVolumePricingCard(sectionId) {
  const quantityInput = document.querySelector(`#Quantity-${sectionId}`);
  const wrapper = document.querySelector(`#SimpleVolumePricingCards-${sectionId}`);
  if (!quantityInput || !wrapper) return;

  const currentQty = Number(quantityInput.value || 0);
  const cards = wrapper.querySelectorAll('.simple-volume-pricing-card');

  cards.forEach((card) => {
    const cardQty = Number(card.dataset.quantity || 0);
    card.classList.toggle('is-active', cardQty === currentQty);
  });
}

function getCurrentVariantId(sectionId) {
  const formVariantInput = document.querySelector(`#product-form-${sectionId} input[name="id"]`);
  if (formVariantInput && formVariantInput.value) return formVariantInput.value;

  const installmentVariantInput = document.querySelector(
    `#product-form-installment-${sectionId} input[name="id"]`
  );
  if (installmentVariantInput && installmentVariantInput.value) return installmentVariantInput.value;

  return null;
}

document.addEventListener('click', (event) => {
  const card = event.target.closest('.simple-volume-pricing-card');
  if (!card) return;

  const wrapper = card.closest('[id^="SimpleVolumePricingCards-"]');
  if (!wrapper) return;

  const sectionId = wrapper.dataset.sectionId;
  const quantityInput = document.querySelector(`#Quantity-${sectionId}`);
  if (!quantityInput) return;

  const targetQty = Number(card.dataset.quantity || 0);
  if (!targetQty) return;

  quantityInput.value = targetQty;
  quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
  quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

  updateActiveVolumePricingCard(sectionId);
});

document.addEventListener('input', (event) => {
  if (!event.target.matches('[id^="Quantity-"]')) return;
  const sectionId = event.target.id.replace('Quantity-', '');
  updateActiveVolumePricingCard(sectionId);
});

document.addEventListener('change', (event) => {
  const sectionId = getSectionIdFromElement(event.target);
  if (!sectionId) return;

  const isQuantityInput = event.target.matches(`#Quantity-${sectionId}`);
  if (isQuantityInput) {
    updateActiveVolumePricingCard(sectionId);
    return;
  }

  const variantId = getCurrentVariantId(sectionId);
  if (!variantId) return;

  window.clearTimeout(window.__simpleVolumePricingTimer);
  window.__simpleVolumePricingTimer = window.setTimeout(() => {
    refreshPriceAndCards(sectionId, variantId);
  }, 150);
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('product-info').forEach((productInfo) => {
    const sectionId = productInfo.dataset.section;
    if (sectionId) updateActiveVolumePricingCard(sectionId);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const productInfo = event.target.querySelector('product-info');
  if (!productInfo) return;
  const sectionId = productInfo.dataset.section;
  if (sectionId) updateActiveVolumePricingCard(sectionId);
});